import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Lookups de segmentação com cache em nível de módulo.
 * Carrega tipos_* ativos UMA vez por sessão — a célula editável NÃO re-busca.
 *
 * Uso:
 *   const { papel, statusOp, realEstate, setores, loading } = useLookupTables();
 *   <EditableCell type="select" options={papel} ... />
 *
 * Cada lookup vem como [{ value: codigo, label: rotulo }].
 */
const cache = {
  papel: null,
  statusOp: null,
  realEstate: null,
  setores: null,
};
let inflight = null;

async function fetchAll() {
  if (inflight) return inflight;
  inflight = (async () => {
    const sels = ['tipos_papel_empresa', 'tipos_status_operacional', 'tipos_real_estate_role', 'tipos_negocio'];
    const [papel, statusOp, realEstate, setores] = await Promise.all(
      sels.map((t) =>
        supabase.from(t).select('codigo, rotulo, ordem').eq('ativo', true).order('ordem')
      )
    );
    const toOpts = (r) => (r.data || []).map((x) => ({ value: x.codigo, label: x.rotulo }));
    cache.papel = toOpts(papel);
    cache.statusOp = toOpts(statusOp);
    cache.realEstate = toOpts(realEstate);
    cache.setores = toOpts(setores);
  })();
  try {
    await inflight;
  } finally {
    inflight = null;
  }
}

export function useLookupTables() {
  const [ready, setReady] = useState(!!cache.papel);

  useEffect(() => {
    let cancelled = false;
    if (cache.papel) {
      setReady(true);
      return;
    }
    fetchAll().then(() => {
      if (!cancelled) setReady(true);
    });
    return () => { cancelled = true; };
  }, []);

  return {
    papel: cache.papel || [],
    statusOp: cache.statusOp || [],
    realEstate: cache.realEstate || [],
    setores: cache.setores || [],
    loading: !ready,
  };
}

/**
 * Opções fixas (não vindas do DB).
 */
export const SENIORIDADE_OPTIONS = [
  { value: '', label: '—' },
  { value: 'junior', label: 'Júnior' },
  { value: 'pleno', label: 'Pleno' },
  { value: 'senior', label: 'Sênior' },
  { value: 'c-level', label: 'C-Level' },
  { value: 'board', label: 'Board' },
];
